export default "__VITE_ASSET__B8y6Tcqc__"